import CouponCodeAdd from "./CouponCodeAdd";
import CouponCodeEdit from "./CouponCodeEdit";
import CouponCodeList from "./CouponCodeList";

export default {
  list: CouponCodeList,
  edit: CouponCodeEdit,
  add: CouponCodeAdd,
};
